export default __webpack_public_path__ + "static/media/Copy of 46265_28-51.860c7c77.jpg";